import React, { useRef } from 'react';
import { extractGoogleDriveId } from '../utils/helpers';
import { useT } from '../utils/i18n';
import '../App.css'; // For responsive iframe styles

const GoogleDrivePlayer = ({ videoUrl, videoId }) => {
  const t = useT();
  const iframeRef = useRef(null);
  const fileId = extractGoogleDriveId(videoUrl);

  // --- IMPORTANT LIMITATION ---
  // Directly listening to play/pause/seek events INSIDE the Google Drive
  // iframe is generally NOT possible due to cross-origin restrictions.
  // The best approach is to log actions based on USER INTENT from
  // custom controls you might build AROUND the iframe, or log when
  // the user interacts with the recording button.
  //
  // This component primarily focuses on embedding the player.
  // Player actions are logged from parent components (e.g. RecordingControls)
  // when the user clicks the app's buttons.

  if (!fileId) {
    return <div className="alert alert-danger">{t('Invalid Google Drive URL or could not extract File ID.')}</div>;
  }

  const embedUrl = `https://drive.google.com/file/d/${fileId}/preview`;

  return (
    <div className="google-drive-player mb-3">
      <h4>{t('Video Preview')}</h4>
      <div className="responsive-iframe-container">
         <iframe
            ref={iframeRef}
            src={embedUrl}
            className="responsive-iframe"
            allow="autoplay; fullscreen" // Allow necessary permissions
            title={`Google Drive Video ${videoId}`}
        ></iframe>
      </div>
    </div>
  );
};

export default GoogleDrivePlayer;
